import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Page from "../../components/Page";
import {
    Section,
    Heading,
    Paragraph,
    IconStatusInformationOnlight,
    FormLayout,
    Loading
} from '@piggybank/core';
import { useTagging } from 'tealiumTrack';
import { timeDiffMaintenance } from "../../utils/date";

const TAG_CONTENT = 'service temporarily unavailable';

const Maintenance = () => {
    const { t, i18n } = useTranslation();
    const lan = i18n.language;
    const maintenanceContext = globalThis.maintenanceContext || {};
    const maintenanceData = {
        ...maintenanceContext,
        status: typeof maintenanceContext.status === 'boolean'
            ? maintenanceContext.status
            : !!maintenanceContext.maintenanceWindowFlag,
        startDate: maintenanceContext.startDate || maintenanceContext.startTime || '',
        endDate: maintenanceContext.endDate || maintenanceContext.endTime || '',
    };
    const M = timeDiffMaintenance(maintenanceData?.startDate, maintenanceData?.endDate);
    console.log('[maintenance page] render', {
        lan,
        maintenanceData,
        computed: M,
    });
    const startDate = M.startFormatStr;
    const endDate = M.endFormatStr;
    const [loading] = useState(false);
    const isPremier = sessionStorage.getItem('AC_TYPE') === 'PREMIER';
    useEffect(() => {
        const timerId = setInterval(() => {
            const getMaintenance = timeDiffMaintenance(maintenanceData?.startDate, maintenanceData?.endDate);
            console.log('[maintenance page] timer check', {
                startDate: maintenanceData?.startDate,
                endDate: maintenanceData?.endDate,
                getMaintenance,
            });
            if (!getMaintenance.status) {
                console.log('[maintenance page] redirecting back to app');
                globalThis.location.href = '/ico-webform/';
            }
        }, 2000);

        return () => clearInterval(timerId);
    });

    useTagging({
        'page_url': '/forms/service-temporarily-unavailable',
        'page_language': lan,
        'event_category': 'error',
        'event_subcategory': 'maintenance',
        'event_action': 'system',
        'event_content': TAG_CONTENT,
        'page_type': 'error',
        'page_name': 'pws:forms:service temporarily unavailable',
        'page_subcategory': TAG_CONTENT,
        'raw_datalayer': '5745v29',
        'funnel_name': `account opening: ${isPremier ? 'premier' : 'one'}`,
        'funnel_step_name': TAG_CONTENT
    });

    return (
        <>
            <Loading show={loading} getApplicationNode={() => document.getElementById('root')}>
                <Heading level={3}>
                    {t('ICO.HAPPENS.PROCESSING')}
                </Heading>
                <Paragraph marginBottom={0}>
                    {t('ICO.HAPPENS.BACK')}
                </Paragraph>
            </Loading>
            <Page hasMargin={0}>
                <FormLayout>
                    <Section marginBottom={3}>
                        <div
                            style={{
                                color: 'var(--sapphire)'
                            }}
                        >
                            <IconStatusInformationOnlight width="2.5em" />
                        </div>
                        <Heading level={1}>
                            {t('ICO.MAINTENANCE.TITLE')}
                        </Heading>
                        <Paragraph>
                            {maintenanceData?.description?.[lan]
                                ? t(maintenanceData.description[lan], { startDate, endDate, defaultValue: maintenanceData.description[lan] })
                                : ''}
                        </Paragraph>
                    </Section>
                </FormLayout>
            </Page>
        </>
    );
}
Maintenance.displayName = 'Maintenance';
export default Maintenance;
